// extracted by mini-css-extract-plugin
export var bodySections = "_7o-8";
export var gray = "_7o-7";
export var green = "_7o-4";
export var iconContainer = "_7o-9";
export var iconWidgetContainer = "_7o-1";
export var phoneIcon = "_7o-2";
export var red = "_7o-5";
export var statusDot = "_7o-3";
export var widgetContainer = "_7o-0";
export var yellow = "_7o-6";